// extracted by mini-css-extract-plugin
module.exports = {"favBtn":"styles_favBtn__GJKdD","icon":"styles_icon__3fwT3","favIcoBtn":"styles_favIcoBtn__2Solp"};